module.exports = new __parcel__URL__("match-browser.a2bb9bea.svg").toString();